export const TABLE_HEADERS = Object.freeze([
	'No.',
	'Customer Phone',
	'Consultant Name',
	'Market',
	'Status',
	'Last Status Change',
	'1st Call Result',
	'1st Call Date',
	'2nd Call Result',
	'2nd Call Date',
]);
